import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.string.includes.js";
import React, { useContext } from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { Form } from '@applyboard/ui-components';
import { useOnboardingFormControllerContext } from "../../../controller/OnboardingFormController";
import { Content } from "./Content";
import { storeFieldsOfEducationValue, getStoredFieldsOfEducation, deleteStoredFieldsOfEducation } from "../../storage/FieldsOfEducation/localStorage";
import { LoadingOverlay } from "../../../../ab-common-legacy/LoadingOverlay";
import { useDeleteStudentPreferences, useEditStudentPreferences, useFieldsOfEducation, useStudentPreferences } from "../../../../data";
import { useAppContext } from "../../../CEF/Providers";
import { FormStateContext } from "../../../FormStateProvider";
export var FieldsOfEducationPage = function FieldsOfEducationPage() {
  var _useAppContext = useAppContext(),
    userId = _useAppContext.userId;
  userId = userId ? userId.toString() : null;
  var _useOnboardingFormCon = useOnboardingFormControllerContext(),
    handlePassed = _useOnboardingFormCon.handlePassed,
    handleSkipped = _useOnboardingFormCon.handleSkipped,
    handleError = _useOnboardingFormCon.handleError;
  var _useContext = useContext(FormStateContext),
    onShowError = _useContext.onShowError;
  var _useFieldsOfEducation = useFieldsOfEducation(),
    options = _useFieldsOfEducation.fieldsOfEducationData;
  var _useStudentPreference = useStudentPreferences(userId, {
      enabled: Boolean(userId)
    }),
    studentPreferences = _useStudentPreference.studentPreferences,
    isLoadingStudentPreferences = _useStudentPreference.isLoadingStudentPreferences;
  var _useEditStudentPrefer = useEditStudentPreferences(userId, 'field_of_education'),
    editStudentPreferences = _useEditStudentPrefer.editStudentPreferences;
  var _useDeleteStudentPref = useDeleteStudentPreferences(userId, 'fields_of_education'),
    deleteStudentPreferences = _useDeleteStudentPref.deleteStudentPreferences;
  if (options.length === 0 || isLoadingStudentPreferences && userId) {
    return /*#__PURE__*/React.createElement(LoadingOverlay, {
      "aria-label": "Loading"
    });
  }
  var signedInSubmit = function signedInSubmit(selectedFields) {
    var data = {
      values: selectedFields,
      type: 'field_of_education'
    };
    editStudentPreferences(data, {
      onSuccess: function onSuccess() {
        var selectedFieldNames = selectedFields.map(function (field) {
          var _options$flatMap$find, _options$flatMap$find2;
          return (_options$flatMap$find = (_options$flatMap$find2 = options.flatMap(function (category) {
            return category.children;
          }).find(function (subcategory) {
            return subcategory.name === field;
          })) === null || _options$flatMap$find2 === void 0 ? void 0 : _options$flatMap$find2.label) !== null && _options$flatMap$find !== void 0 ? _options$flatMap$find : field;
        });
        handlePassed({
          values: selectedFieldNames
        });
      },
      onError: function onError() {
        onShowError();
        handleError();
      }
    });
  };
  var skipFieldOfEducationSubmit = function skipFieldOfEducationSubmit() {
    if (userId) {
      deleteStudentPreferences(undefined, {
        onSuccess: function onSuccess() {
          handleSkipped();
        },
        onError: function onError() {
          onShowError();
          handleError();
        }
      });
    } else {
      deleteStoredFieldsOfEducation();
      handleSkipped();
    }
  };
  var getParentCategory = function getParentCategory(subcategory) {
    var parent = options.find(function (option) {
      return option.children.find(function (sub) {
        return sub.name === subcategory;
      });
    });
    return parent === null || parent === void 0 ? void 0 : parent.name;
  };
  var fieldsSubmit = function fieldsSubmit(data) {
    var fieldsOfEducation = data.fieldsOfEducation;
    var selectedFields = [];
    fieldsOfEducation.forEach(function (key) {
      selectedFields.push(key);

      // if this is a subcategory we also need to include category if it isn't there already
      var parent = getParentCategory(key);
      if (parent && !selectedFields.includes(parent)) {
        selectedFields.push(parent);
      }
    });
    if (userId) {
      signedInSubmit(selectedFields);
    } else {
      var categories = options.map(function (category) {
        return category.name;
      });

      // we need to store the categories and subcategories separately for quick_search
      var selectedCategories = selectedFields.filter(function (selection) {
        return categories.includes(selection);
      });
      var selectedSubcategories = selectedFields.filter(function (selection) {
        return !selectedCategories.includes(selection);
      });
      storeFieldsOfEducationValue(selectedCategories, selectedSubcategories);
      var selectedFieldNames = selectedSubcategories.map(function (field) {
        var _options$flatMap$find3, _options$flatMap$find4;
        return (_options$flatMap$find3 = (_options$flatMap$find4 = options.flatMap(function (category) {
          return category.children;
        }).find(function (subcategory) {
          return subcategory.name === field;
        })) === null || _options$flatMap$find4 === void 0 ? void 0 : _options$flatMap$find4.label) !== null && _options$flatMap$find3 !== void 0 ? _options$flatMap$find3 : field;
      });
      handlePassed({
        values: selectedFieldNames
      });
    }
  };
  var isSelectable = function isSelectable(id) {
    var option = options.find(function (option) {
      return option.name === id;
    });
    // if this option was found it is not a subcategory
    var isCategory = !!option;
    return !isCategory || option.children.length === 0;
  };
  var getDefaultValues = function getDefaultValues() {
    var previousValues = userId ? studentPreferences.fieldOfEducation : getStoredFieldsOfEducation();

    // remove the parent categories for selected subcategories as these don't have a checkbox
    var fieldsOfEducation = previousValues.filter(function (value) {
      return isSelectable(value);
    });
    return {
      fieldsOfEducation: fieldsOfEducation
    };
  };
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: function onSubmit(data) {
      return fieldsSubmit(data);
    },
    defaultValues: getDefaultValues(),
    onSubmitError: function onSubmitError() {
      return handleError();
    }
  }, /*#__PURE__*/React.createElement(Content, {
    options: options,
    skipFieldOfEducationSubmit: skipFieldOfEducationSubmit
  }));
};